import React, { useRef, useState } from "react";

export default function MenuModal({
  category,
  isLoading,
  onClose,
  onSelectProduct,
}) {
  const carouselRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [fullImage, setFullImage] = useState(null);

  if (!category) return null;

  const items = category.items || [];

  const handleScrollEvent = () => {
    if (!carouselRef.current) return;
    const scrollLeft = carouselRef.current.scrollLeft;
    const cardWidth = carouselRef.current.offsetWidth * 0.8;
    const newIndex = Math.round(scrollLeft / cardWidth);

    if (newIndex >= 0 && newIndex < items.length) {
      setActiveIndex(newIndex);
    }
  };

  const scrollCarousel = (direction) => {
    if (!carouselRef.current) return;
    const scrollAmount = carouselRef.current.offsetWidth * 0.7;
    carouselRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className={`modal ${category ? "show" : ""}`} onClick={onClose}>
        <div
          className="sheet menu-modal-sheet"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="sheet-head">
            <div>
              <h2>{category.title}</h2>
              <span className="modal-subtitle">{items.length} Seçenek</span>
            </div>
            <button className="close" onClick={onClose}>
              ✕
            </button>
          </div>

          {/* Body */}
          <div className="modal-slider-body">
            {isLoading ? (
              <div className="modal-loading-state">
                <div className="spinner-ring"></div>
                <p>Yükleniyor...</p>
              </div>
            ) : items.length > 0 ? (
              <>
                <div className="carousel-wrapper">
                  {items.length > 1 && (
                    <button
                      className="carousel-arrow left desktop-only-arrow"
                      onClick={() => scrollCarousel("left")}
                    >
                      ‹
                    </button>
                  )}

                  <div
                    className="products-carousel"
                    ref={carouselRef}
                    onScroll={handleScrollEvent}
                  >
                    {items.map((prod) => (
                      <div key={prod.id} className="carousel-card modern-card">
                        {/* RESME TIKLAYINCA: ZOOM AÇILIR */}
                        <div
                          className="card-image-wrap clickable-zoom"
                          onClick={() => setFullImage(prod.image)}
                          title="Büyütmek için tıklayın"
                        >
                          <img src={prod.image} alt={prod.title} />
                        </div>

                        {/* KARTA / YAZILARA TIKLAYINCA: ÜRÜN DETAYI AÇILIR */}
                        <div
                          className="card-details"
                          onClick={() =>
                            onSelectProduct && onSelectProduct(prod)
                          }
                        >
                          <h3>{prod.title}</h3>
                          <p className="card-desc">{prod.description}</p>

                          <div className="card-footer-row">
                            <div className="price-pills">
                              {prod.portionPrice && (
                                <span className="price-pill-portion">
                                  Porsiyon: <b>{prod.portionPrice}</b>
                                </span>
                              )}
                              {prod.kgPrice && (
                                <span className="price-pill-kg">
                                  Kg: <b>{prod.kgPrice}</b>
                                </span>
                              )}
                            </div>

                            <button className="detail-action-btn">
                              Detay ➔
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {items.length > 1 && (
                    <button
                      className="carousel-arrow right desktop-only-arrow"
                      onClick={() => scrollCarousel("right")}
                    >
                      ›
                    </button>
                  )}
                </div>

                {/* Pagination Dots */}
                {items.length > 1 && (
                  <div className="carousel-dots-wrapper">
                    <div className="carousel-dots">
                      {items.map((_, idx) => (
                        <span
                          key={idx}
                          className={`carousel-dot ${idx === activeIndex ? "active" : ""}`}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="empty-products">
                Bu kategoride ürün bulunamadı.
              </div>
            )}
          </div>
        </div>
      </div>

      {/* FULLSCREEN LIGHTBOX ZOOM */}
      {fullImage && (
        <div
          className="fullscreen-image-overlay"
          onClick={() => setFullImage(null)}
        >
          <button
            className="fullscreen-close-btn"
            onClick={() => setFullImage(null)}
          >
            ✕
          </button>
          <img
            src={fullImage}
            alt="Büyütülmüş Görsel"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
}
